import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { withTranslation } from '@application/i18n/with_translation';
import { UniversalConfig } from '@application/universal_config.service';
import { Button, Flex, restrictedZIndexes, Text, TextLink } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useResolve } from '@visiba/instantiation';
import styled from 'styled-components';
import { ConsentService, UserConsent } from './consent.service';
import { ConsentDialog } from './consent_dialog.component';

export function Consent() {
	const consentService = useResolve(ConsentService);
	const universalConfig = useResolve(UniversalConfig);
	const analyticService = useResolve(AnalyticService);

	function handleAcceptClick() {
		consentService.acceptConsent(UserConsent.Analytic, UserConsent.Functional);

		analyticService.trackEvent(AnalyticCategories.CookieConsent, 'In banner, user accepted additional cookies');
	}

	function handleDenyClick() {
		consentService.acceptConsent();

		analyticService.trackEvent(AnalyticCategories.CookieConsent, 'In banner, user denied additional cookies');
	}

	function handleSettingsClick() {
		analyticService.trackEvent(AnalyticCategories.CookieConsent, 'In banner, user pressed settings');
	}

	return (
		<StyledConcentCard>
			<Flex gap={tokens.spacing.x2}>
				<Text.p variant='bodySmallRegular'>{withTranslation('Component.Consent.Message')}</Text.p>

				<Text variant='bodySmallRegular'>
					{withTranslation('Component.Consent.Dialog.ReadMore')}{' '}
					<TextLink
						size='small'
						href={universalConfig.alias + '/cookie-policy'}
						target='_blank'
						icon='linkOut'
						iconPosition='trailing'
					>
						{withTranslation('Component.Footer.CookiePolicy')}
					</TextLink>
				</Text>
			</Flex>

			<Flex direction='row' gap={tokens.size.x1} justify='space-between'>
				<Flex direction='row' gap={tokens.size.x1}>
					<Button onClick={handleDenyClick} size='xSmall' variant='secondary'>
						{withTranslation('Component.Consent.CTA.Deny')}
					</Button>

					<ConsentDialog
						trigger={
							<Button onClick={handleSettingsClick} size='xSmall' variant='secondary'>
								{withTranslation('Component.Consent.CTA.Settings')}
							</Button>
						}
					/>
				</Flex>
				<Button onClick={handleAcceptClick} size='xSmall' variant='primary'>
					{withTranslation('Component.Consent.CTA.AcceptAll')}
				</Button>
			</Flex>
		</StyledConcentCard>
	);
}

const StyledConcentCard = styled.div`
	pointer-events: auto;
	display: flex;
	max-width: 600px;
	flex-direction: column;
	justify-content: start;
	overflow: hidden;
	background-color: ${tokens.color.bg.surface};
	border-radius: ${tokens.borderRadius.medium};
	box-shadow: ${tokens.elevation.flying};
	padding: ${tokens.spacing.x2};
	border: 1px solid ${tokens.color.border.default};
	gap: ${tokens.spacing.x2};
	z-index: ${restrictedZIndexes.DANGER};
`;
